/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  hasMany,
  belongsTo,
  attr,
  type AsyncBelongsTo,
  type HasMany,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type PersonType from '@linc-technologies/linced-common/enums/person-type';
import type Field from '@linc-technologies/linced-common/models/people-schema/field';
import type School from '@linc-technologies/linced-common/models/school';
import { filterBy } from '@linc-technologies/linced-common/utils/arrays';

// Proto: people_schema.Group.
export default class Group extends Model {
  declare [Type]: 'people-schema/group';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('number', { defaultValue: 0 })
  declare personType: EnumValue<typeof PersonType> | 0;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr('string', { defaultValue: '' })
  declare key: string;

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare customName: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('string', { defaultValue: '' })
  declare templateId: string;

  @hasMany('people-schema/field', { async: false, inverse: 'groupId' })
  declare fields: HasMany<Field>;

  // keyedFields contains the loaded fields that have a key. Use it to copy
  // values by key: a field with no key makes the paths `fields.` and `.value`.
  @computed('fields.@each.key')
  get keyedFields(): Field[] {
    return filterBy(this.fields, 'key');
  }
}
